import { UploadChangeParam, UploadFile } from 'antd/es/upload';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { useCallback } from 'react';
import { getUploadModalState } from '../model/selectors/getUploadModalState';
import { uploadModalActions } from '../model/slice/uploadModalSlice';
import { Dayjs } from 'dayjs';
import { getServerDateWithMinuteTimeFormat } from 'shared/utils/helpers/getDateFormat';

interface HooApi {
  files: Nullable<UploadFile[]>;
  handleFileChange: (data: UploadChangeParam<UploadFile>) => void;
  setUploadDate: (value: Nullable<Dayjs>) => void;
  resetFile: () => void;
  uploadDate?: Nullable<string>;
}

export const useFileUpload = (): HooApi => {
  const dispatch = useAppDispatch();

  const { files } = useAppSelector(getUploadModalState);
  const { uploadDate } = useAppSelector(getUploadModalState);

  const handleFileChange = useCallback(
    (data: UploadChangeParam<UploadFile>): void => {
      const fileList = data.fileList.map((file) => ({ ...file }));

      dispatch(uploadModalActions.setFile(fileList));
    },
    [dispatch],
  );

  const resetFile = useCallback((): void => {
    dispatch(uploadModalActions.resetFile());
  }, [dispatch]);

  const setUploadDate = useCallback(
    (value: Nullable<Dayjs>): void => {
      const uploadDate = getServerDateWithMinuteTimeFormat(value);

      if (uploadDate) {
        dispatch(uploadModalActions.setUploadDate(uploadDate));
      }
    },
    [dispatch],
  );

  return { files, handleFileChange, resetFile, setUploadDate, uploadDate };
};
